const linkHtml = `
  <div id="contact-rekagoo">
    <a href="/#form-top">
      <div class="contact-rekagoo">
        <img alt="修理のご相談はこちら" src="/wp-content/themes/kagoo-premium/images/rekagoo/fix-button.svg">
      </div>
    </a>
    <div class="contact-rekagoo-sp">
      <a href="/#form-body-link">
        <img alt="修理のご相談はこちら" src="/wp-content/themes/kagoo-premium/images/rekagoo/fix-button-sp.svg">
      </a>
    </div>
  </div>
`;

let link;
let $link;

/**
 * @return {boolean}
 */
function isEnabled() {
  return !window.location.pathname.match(/^\/orders\/|^\/repair-form\//);
}

/**
 * @return {boolean}
 */
function isVisible() {
  return window.scrollY > 100;
}

/**
 * @return {boolean}
 */
function isAfterProcessDiv() {
  const processDiv = document.getElementById('process');
  const processDivRect = processDiv.getBoundingClientRect();
  return processDivRect.bottom <= 0; // #process が画面上部にない場合
}

/**
 * @return {HTMLElement}
 */
function createLink() {
  const template = document.createElement('template');
  template.innerHTML = linkHtml;

  return template.content.firstElementChild.cloneNode(true);
}

/**
 * @return {void}
 */
function initialize() {
  link = createLink();
  $link = $(link);

  link.style.display = 'none';
  document.querySelector('footer').appendChild(link);

  // スクロールが100に達したらボタン表示
  window.addEventListener('scroll', () => {
    if (isVisible() && !isAfterProcessDiv()) {
      $link.fadeIn();
    } else {
      $link.fadeOut();
    }
  });
}

// SP 申し込みリンク
document.addEventListener('DOMContentLoaded', () => {
  if (isEnabled()) {
    initialize();
  }
});
